import { ActionCreator } from 'redux';
import { Webhook, WebhookPayload } from '@dev/ee-api/ee-api-models';
import {
    LoadWebhooksAction,
    LoadWebhooksSuccessAction,
    AddWebhookAction,
    AddWebhookSuccessAction,
    DeleteWebhookAction,
    DeleteWebhookSuccessAction,
    WebhookErrorAction,
    UpdateWebhooksSuccessAction,
    UpdateWebhookAction,
    SetSingleWebhookAction,
    ClearSingleWebhookAction,
    ValidateWebhookInputAction,
    ValidateWebhookInputErrorAction,
    SetWebhookToEditAction,
    SetWebhookToEditSuccessAction,
} from './types';

export const LoadWebhooks: ActionCreator<LoadWebhooksAction> = (
    limit?: number,
    offset?: number
): LoadWebhooksAction => ({
    type: '@@webhooks/LOAD_WEBHOOKS',
    paylaod: {
        limit,
        offset,
    },
});
export const LoadWebhooksSuccess: ActionCreator<LoadWebhooksSuccessAction> = (
    webhooks: Webhook[]
): LoadWebhooksSuccessAction => ({
    type: '@@webhooks/LOAD_WEBHOOKS_SUCCESS',
    payload: {
        webhooks,
    },
});

export const AddWebhook: ActionCreator<AddWebhookAction> = (webhook: WebhookPayload): AddWebhookAction => ({
    type: '@@webhooks/ADD_WEBHOOK',
    payload: {
        webhook,
    },
});
export const AddWebhookSuccess: ActionCreator<AddWebhookSuccessAction> = (): AddWebhookSuccessAction => ({
    type: '@@webhooks/ADD_WEBHOOK_SUCCESS',
});

export const DeleteWebhook: ActionCreator<DeleteWebhookAction> = (publicId: string): DeleteWebhookAction => ({
    type: '@@webhooks/DELETE_WEBHOOK',
    payload: {
        publicId,
    },
});
export const DeleteWebhookSuccess: ActionCreator<DeleteWebhookSuccessAction> = (): DeleteWebhookSuccessAction => ({
    type: '@@webhooks/DELETE_WEBHOOK_SUCCESS',
});

export const UpdateWebhook: ActionCreator<UpdateWebhookAction> = (
    publicId: string,
    webhook: WebhookPayload
): UpdateWebhookAction => ({
    type: '@@webhooks/UPDATE_WEBHOOK',
    payload: {
        publicId,
        webhook,
    },
});
export const SetSingleWebhook: ActionCreator<SetSingleWebhookAction> = (
    singleWebhook: WebhookPayload
): SetSingleWebhookAction => ({
    type: '@@webhooks/SET_SINGLE_WEBHOOK',
    payload: {
        singleWebhook,
    },
});
export const SetWebhookToEdit: ActionCreator<SetWebhookToEditAction> = (publicId: string): SetWebhookToEditAction => ({
    type: '@@webhooks/SET_EDITED_VALUES',
    payload: {
        publicId,
        loadingSingleWebhook: true,
    },
});
export const SetWebhookToEditSuccess: ActionCreator<
    SetWebhookToEditSuccessAction
> = (): SetWebhookToEditSuccessAction => ({
    type: '@@webhooks/SET_EDITED_VALUES_SUCCESS',
    payload: {
        loadingSingleWebhook: false,
    },
});
export const ClearSingleWebhook: ActionCreator<ClearSingleWebhookAction> = (): ClearSingleWebhookAction => ({
    type: '@@webhooks/CLEAR_SINGLE_WEBHOOK',
});
export const ValidateInput: ActionCreator<ValidateWebhookInputAction> = (
    name: string,
    value: string,
    type: 'url' | 'string'
): ValidateWebhookInputAction => ({
    type: '@@webhooks/VALIDATE_INPUT',
    payload: {
        name,
        value,
        type,
    },
});
export const SetValidateInputError: ActionCreator<ValidateWebhookInputErrorAction> = (
    errors: string[]
): ValidateWebhookInputErrorAction => ({
    type: '@@webhooks/VALIDATE_INPUT_ERROR',
    payload: {
        errors,
    },
});

export const WebhookError: ActionCreator<WebhookErrorAction> = (): WebhookErrorAction => ({
    type: '@@webhooks/ERROR',
});
export const UpdateWebhookSuccess: ActionCreator<UpdateWebhooksSuccessAction> = (
    webhooks: Webhook[]
): UpdateWebhooksSuccessAction => ({
    type: '@@webhooks/UPDATE_WEBHOOKS_SUCCESS',
    payload: {
        webhooks,
    },
});
